export default __webpack_public_path__ + "static/media/img--interiors-5.57a42505.jpg";